/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Saved2Inputs */

const vi_cmspostcategory_saved2 = /** @type {(inputs: Cmspostcategory_Saved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu chuyên mục.`)
};

/**

* @param {Cmspostcategory_Saved2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_saved2 = /** @type {((inputs?: Cmspostcategory_Saved2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Saved2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_saved2(inputs)
});
export { cmspostcategory_saved2 as "cmsPostCategory_saved" }